"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionFinished = actionFinished;
exports.actionShouldBlock = actionShouldBlock;
function actionShouldBlock(meta) {
  return !meta || !meta.async || !meta.blocking;
}
function actionFinished(type) {
  return type.includes('_SUCCESS') || type.includes('_FAILURE');
}